var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatCsv = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_131196)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_213_131196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 32H7.79982C5.14885 32 2.99982 29.851 2.99982 27.2V4.8C2.99982 2.14903 5.14885 0 7.79982 0H16.4709C17.731 0 18.9406 0.495552 19.8386 1.37968L27.5675 8.98974C28.4838 9.89196 28.9998 11.1241 28.9998 12.4101V27.2C28.9998 29.851 26.8508 32 24.1998 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 31.4H7.79982C5.48022 31.4 3.59982 29.5196 3.59982 27.2V4.8C3.59982 2.4804 5.48022 0.6 7.79982 0.6H16.4709C17.5735 0.6 18.6319 1.03361 19.4176 1.80722L27.1466 9.41728C27.9483 10.2067 28.3998 11.2849 28.3998 12.4101V27.2C28.3998 29.5196 26.5194 31.4 24.1998 31.4Z",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 1V7.8C18 9.56731 19.4327 11 21.2 11H28",
    stroke: "#D3D6D9",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_213_131196)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_213_131196",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H22C23.6569 14 25 15.3431 25 17V25C25 26.6569 23.6569 28 22 28H3C1.34315 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H22C23.6569 14 25 15.3431 25 17V25C25 26.6569 23.6569 28 22 28H3C1.34315 28 0 26.6569 0 25V17Z",
    fill: "#1F8957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H22C24.0987 13.2 25.8 14.9013 25.8 17H24.2C24.2 15.785 23.215 14.8 22 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM25 28H0H25ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM22 13.2C24.0987 13.2 25.8 14.9013 25.8 17V24.2C25.8 26.2987 24.0987 28 22 28C23.215 28 24.2 26.6569 24.2 25V17C24.2 15.785 23.215 14.8 22 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_213_131196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10938 19.7594H7.94063C7.90729 19.5677 7.84583 19.3979 7.75625 19.25C7.66667 19.1 7.55521 18.9729 7.42188 18.8687C7.28854 18.7646 7.13646 18.6865 6.96563 18.6344C6.79688 18.5802 6.61458 18.5531 6.41875 18.5531C6.07083 18.5531 5.7625 18.6406 5.49375 18.8156C5.225 18.9885 5.01458 19.2427 4.8625 19.5781C4.71042 19.9115 4.63438 20.3187 4.63438 20.8C4.63438 21.2896 4.71042 21.7021 4.8625 22.0375C5.01667 22.3708 5.22708 22.6229 5.49375 22.7937C5.7625 22.9625 6.06979 23.0469 6.41563 23.0469C6.60729 23.0469 6.78646 23.0219 6.95313 22.9719C7.12188 22.9198 7.27292 22.8437 7.40625 22.7437C7.54167 22.6437 7.65521 22.5208 7.74688 22.375C7.84063 22.2292 7.90521 22.0625 7.94063 21.875L9.10938 21.8812C9.06563 22.1854 8.97083 22.4708 8.825 22.7375C8.68125 23.0042 8.49271 23.2396 8.25938 23.4437C8.02604 23.6458 7.75313 23.8042 7.44063 23.9187C7.12813 24.0312 6.78125 24.0875 6.4 24.0875C5.8375 24.0875 5.33542 23.9573 4.89375 23.6969C4.45208 23.4365 4.10417 23.0604 3.85 22.5687C3.59583 22.0771 3.46875 21.4875 3.46875 20.8C3.46875 20.1104 3.59688 19.5208 3.85313 19.0312C4.10938 18.5396 4.45833 18.1635 4.9 17.9031C5.34167 17.6427 5.84167 17.5125 6.4 17.5125C6.75625 17.5125 7.0875 17.5625 7.39375 17.6625C7.7 17.7625 7.97292 17.9094 8.2125 18.1031C8.45208 18.2948 8.64896 18.5302 8.80313 18.8094C8.95938 19.0865 9.06146 19.4031 9.10938 19.7594ZM13.8252 19.3594C13.7961 19.0865 13.6731 18.874 13.4565 18.7219C13.2419 18.5698 12.9627 18.4937 12.619 18.4937C12.3773 18.4937 12.17 18.5302 11.9971 18.6031C11.8242 18.676 11.6919 18.775 11.6002 18.9C11.5086 19.025 11.4617 19.1677 11.4596 19.3281C11.4596 19.4615 11.4898 19.5771 11.5502 19.675C11.6127 19.7729 11.6971 19.8562 11.8033 19.925C11.9096 19.9917 12.0273 20.0479 12.1565 20.0937C12.2856 20.1396 12.4158 20.1781 12.5471 20.2094L13.1471 20.3594C13.3888 20.4156 13.6211 20.4917 13.844 20.5875C14.069 20.6833 14.27 20.8042 14.4471 20.95C14.6263 21.0958 14.7679 21.2719 14.8721 21.4781C14.9763 21.6844 15.0283 21.926 15.0283 22.2031C15.0283 22.5781 14.9325 22.9083 14.7408 23.1937C14.5492 23.4771 14.2721 23.699 13.9096 23.8594C13.5492 24.0177 13.1127 24.0969 12.6002 24.0969C12.1023 24.0969 11.67 24.0198 11.3033 23.8656C10.9388 23.7115 10.6533 23.4865 10.4471 23.1906C10.2429 22.8948 10.1325 22.5344 10.1158 22.1094H11.2565C11.2731 22.3323 11.3419 22.5177 11.4627 22.6656C11.5836 22.8135 11.7408 22.924 11.9346 22.9969C12.1304 23.0698 12.3492 23.1062 12.5908 23.1062C12.8429 23.1062 13.0638 23.0687 13.2533 22.9937C13.445 22.9167 13.595 22.8104 13.7033 22.675C13.8117 22.5375 13.8669 22.3771 13.869 22.1937C13.8669 22.0271 13.8179 21.8896 13.7221 21.7812C13.6263 21.6708 13.4919 21.5792 13.319 21.5062C13.1481 21.4312 12.9481 21.3646 12.719 21.3062L11.9908 21.1187C11.4638 20.9833 11.0471 20.7781 10.7408 20.5031C10.4367 20.226 10.2846 19.8583 10.2846 19.4C10.2846 19.0229 10.3867 18.6927 10.5908 18.4094C10.7971 18.126 11.0773 17.9062 11.4315 17.75C11.7856 17.5917 12.1867 17.5125 12.6346 17.5125C13.0888 17.5125 13.4867 17.5917 13.8283 17.75C14.1721 17.9062 14.4419 18.124 14.6377 18.4031C14.8336 18.6802 14.9346 18.999 14.9408 19.3594H13.8252ZM17.0942 17.6L18.7598 22.6375H18.8254L20.4879 17.6H21.7629L19.5067 24H18.0754L15.8223 17.6H17.0942Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_213_131196",
    x: 1.39982,
    y: -3.2,
    width: 29.2,
    height: 37.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_131196"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_213_131196",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_213_131196"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_213_131196",
    x: 0,
    y: 14,
    width: 25,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_213_131196"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_131196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatCsv);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatCsv.286b664932a967914527e0305676ec2c.svg";